import { __read, __spreadArray } from "tslib";
import { useEffect } from 'react';
import { _INTERNAL_EVENT_API_NAMES, _INTERNAL_EVENT_TYPE } from '../events';
import { warnLogger } from '../utils/logger';
import { useCurrentRef } from '../utils/useCurrentRef';
import { _useContext } from './_useContext';
//
//
//
/**
 * A hook to handle Channel IO event.
 *
 * @see https://developers.channel.io/docs/web-channelio
 */
export var useChannelIOEvent = function (name, callback) {
    var callbackRef = useCurrentRef(callback);
    _useContext();
    //
    // Add event listener for Channel IO event.
    //
    useEffect(function () {
        if (!_INTERNAL_EVENT_API_NAMES.includes(name)) {
            warnLogger('Given method name is not exist at Channel IO.', 'Please refer https://developers.channel.io/docs/web-channelio.');
            return;
        }
        /**
         * Handle Channel IO event.
         */
        var _handle = function (evt) {
            var detail = evt === null || evt === void 0 ? void 0 : evt.detail;
            if (name !== detail.name) {
                return;
            }
            if (typeof callbackRef.current === 'function') {
                callbackRef.current.apply(callbackRef, __spreadArray([], __read(detail.args), false));
            }
        };
        document.addEventListener(_INTERNAL_EVENT_TYPE, _handle, false);
        return function () {
            document.removeEventListener(_INTERNAL_EVENT_TYPE, _handle, false);
        };
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [name]);
};
